import {ProductKeyByHostEnum} from 'presentation/constants';

type FirebaseAppObjectModel = {
	apiKey?: string;
	authDomain: string;
	databaseURL: string;
	projectId: string;
	storageBucket: string;
	messagingSenderId: string;
	appId: string;
	measurementId: string;
};

type FirebaseConfigModel = {
	[ProductKeyByHostEnum.HAP]: FirebaseAppObjectModel;
	[ProductKeyByHostEnum.CCG]: FirebaseAppObjectModel;
	[ProductKeyByHostEnum.CLINIPAM]: FirebaseAppObjectModel;
	[ProductKeyByHostEnum.GNDI_MINAS]: FirebaseAppObjectModel;
	[ProductKeyByHostEnum.GNDI]: FirebaseAppObjectModel;
	[ProductKeyByHostEnum.NOTREDAME_SAUDE]: FirebaseAppObjectModel;
};

export const firebaseConfig: FirebaseConfigModel = {
	[ProductKeyByHostEnum.HAP]: {
		apiKey: process.env.FIREBASE_API_KEY,
		authDomain: 'wise-groove-250316.firebaseapp.com',
		databaseURL: 'https://wise-groove-250316.firebaseio.com',
		projectId: 'wise-groove-250316',
		storageBucket: 'wise-groove-250316.appspot.com',
		messagingSenderId: '733137251585',
		appId: '1:733137251585:web:729861be495f4025433f00',
		measurementId: 'G-P2981W6QNK',
	},
	[ProductKeyByHostEnum.CCG]: {
		apiKey: process.env.FIREBASE_API_KEY,
		authDomain: 'wise-groove-250316.firebaseapp.com',
		databaseURL: 'https://wise-groove-250316.firebaseio.com',
		projectId: 'wise-groove-250316',
		storageBucket: 'wise-groove-250316.appspot.com',
		messagingSenderId: '733137251585',
		appId: '1:733137251585:web:4e018888ebe9e593433f00',
		measurementId: 'G-QVNEHX3R0Z',
	},
	[ProductKeyByHostEnum.CLINIPAM]: {
		apiKey: process.env.FIREBASE_API_KEY,
		authDomain: 'wise-groove-250316.firebaseapp.com',
		databaseURL: 'https://wise-groove-250316.firebaseio.com',
		projectId: 'wise-groove-250316',
		storageBucket: 'wise-groove-250316.appspot.com',
		messagingSenderId: '733137251585',
		appId: '1:733137251585:web:1f5e20b6fef55f32433f00',
		measurementId: 'G-M8W4409T26',
	},
	[ProductKeyByHostEnum.GNDI_MINAS]: {
		apiKey: process.env.FIREBASE_API_KEY,
		authDomain: 'wise-groove-250316.firebaseapp.com',
		databaseURL: 'https://wise-groove-250316.firebaseio.com',
		projectId: 'wise-groove-250316',
		storageBucket: 'wise-groove-250316.appspot.com',
		messagingSenderId: '733137251585',
		appId: '1:733137251585:web:ba46ba88addf6993433f00',
		measurementId: 'G-RVQ23VCNH1',
	},
	[ProductKeyByHostEnum.GNDI]: {
		apiKey: process.env.FIREBASE_API_KEY,
		authDomain: 'wise-groove-250316.firebaseapp.com',
		databaseURL: 'https://wise-groove-250316.firebaseio.com',
		projectId: 'wise-groove-250316',
		storageBucket: 'wise-groove-250316.appspot.com',
		messagingSenderId: '733137251585',
		appId: '1:733137251585:web:d97a54112e998e7a433f00',
		measurementId: 'G-DH2SKB1TPY',
	},
	[ProductKeyByHostEnum.NOTREDAME_SAUDE]: {
		apiKey: process.env.FIREBASE_API_KEY,
		authDomain: 'wise-groove-250316.firebaseapp.com',
		databaseURL: 'https://wise-groove-250316.firebaseio.com',
		projectId: 'wise-groove-250316',
		storageBucket: 'wise-groove-250316.appspot.com',
		messagingSenderId: '733137251585',
		appId: '1:733137251585:web:d97a54112e998e7a433f00',
		measurementId: 'G-DH2SKB1TPY',
	},
};
